import React from "react";

import "./styles.scss";

interface IPageTitleProps {
  text?: string;
}

export const PageTitle: React.FunctionComponent<IPageTitleProps> = ({
  text,
}) => {
  return <span className="page-title">{text}</span>;
};
